// extracted by mini-css-extract-plugin
export var banner = "_bd-0";
export var closeButton = "_bd-2";
export var greenCheckmark = "_bd-3";
export var hereLink = "_bd-4";
export var titleIcon = "_bd-1";